import { z } from 'zod';
import { moderationStateSchema } from './enums';
/**
 * A comment, as read by any member.
 *
 * `path`/`depth` implement the materialised-path threading described on the
 * Comment model in prisma/schema.prisma — comments for a topic are fetched in
 * one indexed, path-ordered query and rendered with indentation from `depth`,
 * rather than walked recursively.
 */
export const commentSchema = z.object({
    id: z.string(),
    topicId: z.string(),
    authorId: z.string(),
    authorDisplayName: z.string(),
    authorDepartment: z.string().nullable(),
    parentCommentId: z.string().nullable(),
    path: z.string(),
    depth: z.number().int(),
    body: z.string(),
    moderationState: moderationStateSchema,
    voteScore: z.number().int(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    publishedAt: z.coerce.date().nullable(),
    myVote: z.union([z.literal(1), z.literal(-1), z.null()]),
});
/** topicId comes from the URL (`POST /topics/:topicId/comments`), not the body. */
export const createCommentSchema = z.object({
    parentCommentId: z.string().optional(),
    body: z.string().trim().min(1, 'Comment cannot be empty').max(10_000),
});
/** Author self-edit. */
export const updateCommentSchema = z.object({
    body: z.string().trim().min(1, 'Comment cannot be empty').max(10_000),
});
/** See createTopicResponseSchema in topics.ts — same reasoning. */
export const createCommentResponseSchema = z.object({
    comment: commentSchema,
    supportNotice: z.boolean(),
});
//# sourceMappingURL=comments.js.map